import { http } from "../api/http";
import Utils from "../utils";

export const clientConnectorService = {
  get,
  suggestions,
  create,
  update,
  testConnectorAuth,
  pushOnPremUpdate,
  getOnPremInstallerUrl,
  setOnPremAutoUpdate,
  collectOnPremLog,
  getOnPremLogUrl,
  remove,
};

async function get(requestParameters) {
  let url = `/clientconnector?${Utils.objectToQueryString(requestParameters)}`;

  const response = await http.get(url);
  return response;
}

async function suggestions(requestParameters) {
  let url = `/clientconnector/suggestions?${Utils.objectToQueryString(
    requestParameters
  )}`;

  const response = await http.get(url);
  return response;
}

async function create(requestBody) {
  let url = `/clientconnector/create`;

  const response = await http.post(url, JSON.stringify(requestBody));
  return response;
}

async function update(requestBody) {
  let url = `/clientconnector/update`;

  const response = await http.patch(url, JSON.stringify(requestBody));
  return response;
}

async function testConnectorAuth(requestBody) {
  let url = `/clientconnector/testConnectorAuth`;

  const response = await http.post(url, JSON.stringify(requestBody));
  return response;
}

async function pushOnPremUpdate(requestBody) {
  let url = `/clientconnector/pushOnPremUpdate`;

  const response = await http.post(url, JSON.stringify(requestBody));
  return response;
}

async function getOnPremInstallerUrl(forCopy = false) {
  // Returns { downloadUrl, fileName, version, expiresUtc } — a SAS URL to the active installer. The
  // browser downloads directly from it (native progress) or the admin copies it to send to a client.
  // forCopy=true asks for a longer-lived link (the client self-downloads it later).
  const url = `/clientconnector/onPremInstallerUrl${forCopy ? "?forCopy=true" : ""}`;
  const response = await http.get(url);
  return response;
}

async function setOnPremAutoUpdate(requestBody) {
  let url = `/clientconnector/setOnPremAutoUpdate`;
  const response = await http.post(url, JSON.stringify(requestBody));
  return response;
}

async function collectOnPremLog(requestBody) {
  // Dispatches a "Download Server Log" to the OnPrem agent (super user). The agent collects its
  // recent Event Log and posts it back to the cloud; poll getOnPremLogUrl for the result.
  const url = `/clientconnector/collectOnPremLog`;
  const response = await http.post(url, JSON.stringify(requestBody));
  return response;
}

async function getOnPremLogUrl(clientId, clientGuid) {
  // Polls the log request status. Returns { status, downloadUrl?, fileName?, logTime?, expiresUtc? }.
  // status is Pending / Ready / Failed / NoResponse / None.
  const url = `/clientconnector/onPremLogUrl?clientId=${encodeURIComponent(
    clientId
  )}&clientGuid=${encodeURIComponent(clientGuid)}`;
  const response = await http.get(url);
  return response;
}

async function remove(requestParameters) {
  let url = `/clientconnector/delete?${Utils.objectToQueryString(requestParameters)}`;
  const response = await http.delete(url);
  return response;
}
